module.exports = __webpack_public_path__ + "img/bg_services.da4a72ea.jpg";